<template>
    <b-container fluid>
        <!-- User Interface controls -->
        <b-row class="filters">
            <!-- <b-col lg="6" class="my-1 filters">
                <b-form-group
                        label="Sort"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="sortBySelect"
                        class="mb-0"
                >
                    <b-input-group size="sm">
                        <b-form-select v-model="sortBy" id="sortBySelect" :options="sortOptions" class="w-75">
                            <template v-slot:first>
                                <option value="">-- none --</option>
                            </template>
                        </b-form-select>
                        <b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy" class="w-25">
                            <option :value="false">Asc</option>
                            <option :value="true">Desc</option>
                        </b-form-select>
                    </b-input-group>
                </b-form-group>
            </b-col>

             <b-col lg="6" class="my-1">
                <b-form-group
                        label="Initial sort"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="initialSortSelect"
                        class="mb-0"
                >
                    <b-form-select
                            v-model="sortDirection"
                            id="initialSortSelect"
                            size="sm"
                            :options="['asc', 'desc', 'last']"
                    ></b-form-select>
                </b-form-group>
            </b-col> -->

            <b-col sm="6" md="6" class="my-1">
                <b-form-group
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="filterInput"
                        class="mb-0"
                >
                    <b-input-group size="sm">
                        <b-form-input
                                v-model="filter"
                                type="search"
                                id="filterInput"
                                placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col sm="6" md="6" class="my-1">
                <b-form-group
                        v-if="filters"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                        <b-form-checkbox v-for="chk in filters" :key="chk.label" :value="chk.filter">{{chk.label}}</b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <!-- Main table element -->
            <b-table
                    show-empty
                    small
                    stacked="lg"
                    striped
                    table-variant=""
                    head-variant="light"
                    :items="recordlist"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filterIncludedFields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="onFiltered"
            >
                <template v-slot:cell(name)="row">
                    <div v-if="row.value.first">{{ row.value.first }} {{ row.value.last }}</div>
                    <div v-else>{{row.value}}</div>
                </template>

                <template v-slot:cell(start)="row">
                    <div>{{row.value | formatDate}}</div>
                </template>

                <template v-slot:cell(end)="row">
                    <div>{{row.value | formatDate}}</div>
                </template>

                <template v-slot:cell(date)="row">
                    <div>{{row.value | formatDate}}</div>
                </template>

                <template v-slot:cell(purchased)="row">
                    <div>{{row.value | formatDate}}</div>
                </template>

                <template v-slot:cell(actions)="row">
                    <div v-for="act in actions" :key="act.label" style="float:right">
                        <b-button v-if="act.refvalue" size="sm" :variant="row.item[act.refvalue] ? act.variant : act.false_variant" @click="$emit(act.event, row.item, $event)">
                            <component v-if="act.icon" :is="act.icon"></component>
                            <div v-else>{{act.label}}</div>
                        </b-button>
                        <b-button v-else size="sm" :variant="act.variant" @click="$emit(act.event, row.item, $event)" class="mr-1">
                            <component v-if="act.icon" :is="act.icon"></component>
                            <div v-else>{{act.label}}</div>
                        </b-button>
                    </div>
                </template>

                <template v-slot:cell(html)="data">
                    <span v-html="data.value"></span>
                </template>

            </b-table>
        </b-row>
        <b-row class="bottom_filters">
            <b-col sm></b-col>
            <b-col sm="3" md="4" class="my-1">
                <b-form-group
                        label="Per page"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="perPageSelect"
                        class="mb-0"
                >
                    <b-form-select
                            v-model="perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="pageOptions"
                    ></b-form-select>
                </b-form-group>
            </b-col>

            <b-col sm="2" md="3" class="my-1">
                <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        size="sm"
                        class="my-0"
                ></b-pagination>
            </b-col>
            <b-col sm></b-col>
        </b-row>

    </b-container>
</template>

<script>
    import moment from 'moment'
    moment.locale('IT');

    export default {
        name:'genericTable',
        props: ['items', 'fields', 'filters', 'actions'],
        data() {
            return {
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 15],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                recordlist: []
            }
        },
        computed: {
            totalRows() {
                return this.recordlist.length;
            },
            sortOptions() {
                // Create an options list from our fields
                return this.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return { text: f.label, value: f.key }
                    })
            }
        },
        filters:{
            formatDate: function (_value) {
                if(_value){
                    return new moment(_value * 1000).format('LLL');
                }
                return null;
            }
        },
        methods: {
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            addRecord(_record){
                this.recordlist.push(_record);
            },
            clearRecords(){
                this.recordlist.length=0;
                this.recordlist.sort();
            }

        }
    }
</script>

<style scoped>

    /deep/ th {
        background-color: rgba(167, 167, 167, 0.8) !important;
        height:40px !important;
        border-bottom: 1px solid black !important;
    }

    .header {
        background-color: #d7d7d7;
    }

    .filters{
        background-color: #d7d7d7;
    }
    .bottom_filters{
        background-color: #d7d7d7;
        /*position: absolute;
        width: 100%;
        bottom: 0;*/
    }
</style>
